import { ReactNode, useEffect } from 'react';
import { initMixpanelAnalytics } from './analytics';
import { usePageTracking } from './hooks/usePageTracking';
import { useAuth } from '../context/AuthContext';
import { syncAnalyticsUserIdentity } from './identity';

interface AnalyticsProviderProps {
  children: ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const { currentUser } = useAuth();

  useEffect(() => {
    initMixpanelAnalytics();
  }, []);

  useEffect(() => {
    if (currentUser?.id) {
      syncAnalyticsUserIdentity(currentUser);
    }
  }, [currentUser?.id, currentUser?.email, currentUser?.name, currentUser?.userType]);

  usePageTracking(true);

  return <>{children}</>;
}
